import * as React from 'react';
import {
  GetOrganizationDocument,
  useUpdateCombinedOrganizationSettingsMutation,
  useUpdateUserOnlineMarketingMutation,
  useUpdateWorkspaceMutation
} from '../../../models/graphql';
import { AccountController } from './Account.controller';
import { gql } from '@apollo/client';
import { useSelectedOrganization } from '../../../hooks/useSelectedOrganization';

gql`
  mutation UpdateCombinedOrganizationSettings(
    $input: CombinedOrganizationSettingsInput!
    $organizationId: ID!
    $userId: ID
  ) {
    updateOrganizationSettings(input: $input, organizationId: $organizationId, userId: $userId) {
      userOrganizationSettings {
        id
        timeFormat
        dateFormat
        startOfWeekFormat
      }
      organizationSettings {
        id
        productAnalyticsEnabled
      }
    }
  }
  mutation UpdateUserOnlineMarketing($onlineMarketing: Boolean!, $userId: ID) {
    updateUserSettings(input: { onlineMarketing: $onlineMarketing }, userId: $userId) {
      id
      onlineMarketing
      notifyFeatureAddedEnabled
      notifyMailingListEnabled
      notifyProductUpdatesEnabled
      notifyReferralCreditsEnabled
    }
  }

  query HelpscoutMetadata {
    helpscoutMetadata {
      beaconId
      email
      signature
    }
  }
`;

export const AccountApollo = (): JSX.Element => {
  const { selectedOrganization } = useSelectedOrganization();

  const [updateCombinedOrganizationSettings] = useUpdateCombinedOrganizationSettingsMutation();
  const [updateUserOnlineMarketing] = useUpdateUserOnlineMarketingMutation();
  const [updateWorkspace] = useUpdateWorkspaceMutation({
    refetchQueries: [
      {
        query: GetOrganizationDocument,
        variables: { organizationId: selectedOrganization?.id }
      }
    ]
  });

  return (
    <AccountController
      updateCombinedOrganizationSettings={updateCombinedOrganizationSettings}
      updateUserOnlineMarketing={updateUserOnlineMarketing}
      updateWorkspace={updateWorkspace}
    />
  );
};
